import React, { Component } from "react";
import ProgressiveImage from "react-progressive-image";
import ProfilePicture from "@dsalvagni/react-profile-picture";
import "@dsalvagni/react-profile-picture/build/ProfilePicture.css";
export class ImageUploader extends Component {
    state = {
        edit: false
    };

    render() {
        const { currentImage, ImageRef } = this.props;
        return (
            <div>
                {this.state.edit ? (
                    <div>
                        <ProfilePicture
                            ref={ImageRef}
                            useHelper={false}
                            debug={false}
                            minImageSize={250}
                            maxImageSize={250}
                            frameSize={250}
                            frameFormat="circle"
                            backgroundSize={200}
                            showFrame={true}
                            cropSize={250}
                        />

                        <div style={{ justifyContent: "flex-end" }}>
                            <a title="Edit Image" role="button" onClick={() =>
                                this.setState({
                                    edit: false,
                                })
                            }
                            >
                                Cancel
                            </a>
                        </div>
                    </div>
                ) : (
                    <div>
                        <ProgressiveImage src={currentImage} placeholder={currentImage}>
                            {src => <img alt="" src={currentImage} style={{ maxWidth: "250px", borderRadius: "50%", border: "7.5px solid white" }} title="Edit Image" onClick={() =>
                                this.setState({
                                    edit: true
                                })
                            } />}
                        </ProgressiveImage>
                    </div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/generic/ImageUploader.js